module.exports = __webpack_public_path__ + "img/38.1.f436e562.jpg";